angular.module('rjmNg.controllers').controller('dashboardItemCtrl', [
  "$location"
  "$q"
  "$routeParams"
  "$scope"
  "Charts"
  "reportBuilder"
  (
    $location
    $q
    $routeParams
    $scope
    Charts
    reportBuilder
  ) ->

    _getChartTypeFromFigureId = (figureId) ->
      deferred = $q.defer()
      Charts.getCharts().then( (data) ->
        try
          charts = data
          for chart in charts when chart.figureId is figureId
            deferred.resolve(chart.reportQueryType)
            return
        catch error
          deferred.reject(error)
          return
      )
      return deferred.promise

    # Logic for displaying the highchart directive
    _shouldWeDisplayFigure = () ->
      # If we have a figure, show the figure, otherwise show the chart
      return if $scope.$parent?.dashboardItem?.figureId? then true else false

    $scope.displayFigure = _shouldWeDisplayFigure()

    _changePathWithoutReportQueryType = (figureId) ->
      _getChartTypeFromFigureId(figureId).then((type) ->
        _changeLocationPathToEdit(figureId, type)
      )

    _changeLocationPathToEdit = (figureId, reportQueryType) ->
      path = reportBuilder.getReportBuilderPath(figureId, reportQueryType)

      if $routeParams.dashId?
        $location.path(path).search('dashboardId', $routeParams.dashId)
      else
        $location.path(path)

    $scope.editFigure = (figureId, allowEdit, reportQueryType) ->
      if not allowEdit
        return

      if not reportQueryType?
        _changePathWithoutReportQueryType(figureId)
      else
        _changeLocationPathToEdit(figureId, reportQueryType)

    $scope.$on 'hideChartsAndFigures', ->
      $scope.dashboardItemHidden = true
    $scope.$on 'showChartsAndFigures', ->
      $scope.dashboardItemHidden = false
])
